// https://github.com/bpmn-io/bpmn-js-i18n/blob/main/translations/de.js

/**
 * This file contains German translations for other components.
 */
export const base1 = {
    'Activate create/remove space tool':
        'Platz-hinzufügen/entfernen-Tool aktivieren',
    'Activate global connect tool': 'Globales Verbindungswerkzeug aktivieren',
    'Activate hand tool': 'Hand-Tool aktivieren',
    'Activate lasso tool': 'Lasso-Tool aktivieren',
    'Ad-hoc': 'Ad-hoc',
    'Ad-hoc sub-process (collapsed)': 'Ad-hoc-Unterprozess (reduziert)',
    'Ad-hoc sub-process (expanded)': 'Ad-hoc-Unterprozess (erweitert)',
    'Add lane above': 'Lane oberhalb hinzufügen',
    'Add lane below': 'Lane unterhalb hinzufügen',
    'Add text annotation': 'Textanmerkung hinzufügen',
    'Align elements': 'Elemente ausrichten',
    'Align elements bottom': 'Elemente unten ausrichten',
    'Align elements center': 'Elemente zentrieren',
    'Align elements left': 'Elemente links ausrichten',
    'Align elements middle': 'Elemente mittig ausrichten',
    'Align elements right': 'Elemente rechts ausrichten',
    'Align elements top': 'Elemente oben ausrichten',
    'Append compensation activity': 'Kompensation hinzufügen',
    'Append conditional intermediate catch event':
        'ConditionIntermediateCatchEvent anhängen',
    'Append end event': 'Endereignis anhängen',
    'Append gateway': 'Gateway anhängen',
    'Append intermediate/boundary event':
        'Angeheftetes / Zwischenereignis anhängen',
    'Append message intermediate catch event':
        'Eintretendes Nachrichten-Zwischenereignis anhängen',
    'Append receive task': 'Empfangen Aufgabe anhängen',
    'Append signal intermediate catch event':
        'Eintretendes Signal-Zwischenereignis anhängen',
    'Append task': 'Aufgabe anhängen',
    'Append text annotation': 'Textannotation anhängen',
    'Append timer intermediate catch event':
        'Eintretendes Zeit-Zwischenereignis anhängen',
    'Business rule task': 'Geschäftsregel Aufgabe',
    'Call activity': 'Aufruf-Aktivität',
    'Cancel boundary event': 'Angeheftetes Abbruch-Zwischenereignis',
    'Cancel end event': 'Abbruch-Endereignis',
    'Change element': 'Element ändern',
    'Change type': 'Typ ändern',
    Collection: 'Collection',
    'Compensation boundary event':
        'Angeheftetes Kompensations-Zwischenereignis',
    'Compensation end event': 'Kompensations-Endereignis',
    'Compensation intermediate throw event':
        'Ausgelöstes Kompensations-Zwischenereignis',
    'Compensation start event': 'Kompensations-Startereignis',
    'Complex gateway': 'Komplexes Gateway',
    'Conditional boundary event': 'Angeheftetes bedingtes Zwischenereignis',
    'Conditional boundary event (non-interrupting)':
        'Angeheftetes bedingtes Zwischenereignis (nicht unterbrechend)',
    'Conditional flow': 'Bedingter Sequenzfluss',
    'Conditional intermediate catch event':
        'Eintretendes bedingtes Zwischenereignis',
    'Conditional start event': 'Bedingtes Startereignis',
    'Conditional start event (non-interrupting)':
        'Bedingtes Startereignis (nicht unterbrechend)',
    'Connect to other element': 'Mit anderem Element verbinden',
    'Connect using association': 'Mit Assoziation verbinden',
    'Connect using data input association':
        'Mit DataInputAssociation verbinden',
    'Connect using sequence/message flow or association':
        'Mit Sequenzfluss/Nachrichtenfluss oder Assoziation verbinden',
    'Create data object reference': 'Referenzen auf Datenobjekt erzeugen',
    'Create data store reference':
        'Referenzen auf Datenspeicherobjekt erzeugen',
    'Create end event': 'Endereignis erstellen',
    'Create expanded sub-process': 'Erweiterten SubProcess erzeugen',
    'Create gateway': 'Gateway erstellen',
    'Create group': 'Gruppe erzeugen',
    'Create intermediate/boundary event': 'Zwischen-/Grenzereignis erzeugen',
    'Create pool/participant': 'Pool/Teilnehmer erzeugen',
    'Create start event': 'Startereignis erzeugen',
    'Create task': 'Aufgabe erzeugen',
    'Data object reference': 'Referenz auf Datenobjekt',
    'Data store reference': 'Referenz auf Datenspeicher',
    'Default flow': 'Standard-Sequenzfluss',
    Delete: 'Löschen',
    'Distribute elements horizontally': 'Elemente horizontal verteilen',
    'Distribute elements vertically': 'Elemente vertikal verteilen',
    'Divide into three lanes': 'In drei Lanes aufteilen',
    'Divide into two lanes': 'In zwei Lanes aufteilen',
    'Empty pool/participant': 'Leerer Pool',
    'Empty pool/participant (removes content)': 'Leerer Pool (entfernt Inhalt)',
    'End event': 'Endereignis',
    'Error boundary event': 'Angeheftetes Fehler-Zwischenereignis',
    'Error end event': 'Fehler-Endereignis',
    'Error start event': 'Fehler-Startereignis',
    'Escalation boundary event': 'Angeheftetes Eskalations-Zwischenereignis',
    'Escalation boundary event (non-interrupting)':
        'Angeheftetes Eskalations-Zwischenereignis (nicht unterbrechend)',
    'Escalation end event': 'Eskalations-Endereignis',
    'Escalation intermediate throw event':
        'Ausgelöstes Eskalations-Zwischenereignis',
    'Escalation start event': 'Eskalations-Startereignis',
    'Escalation start event (non-interrupting)':
        'Eskalations-Startereignis (nicht unterbrechend)',
    'Event sub-process': 'Ereignis-Teilprozess',
    'Event-based gateway': 'Ereignis-basiertes Gateway',
    'Exclusive gateway': 'Exklusives Gateway',
    'Inclusive gateway': 'Inklusives Gateway',
    'Intermediate throw event': 'Zwischenereignis',
    'Link intermediate catch event': 'Eintretendes Link-Zwischenereignis',
    'Link intermediate throw event': 'Ausgelöstes Link-Zwischenereignis',
    Loop: 'Schleife',
    'Manual task': 'Manuelle Aufgabe',
    'Message boundary event': 'Angeheftetes Nachrichten-Zwischenereignis',
    'Message boundary event (non-interrupting)':
        'Angeheftetes Nachrichten-Zwischenereignis (nicht unterbrechend)',
    'Message end event': 'Nachrichten-Endereignis',
    'Message intermediate catch event':
        'Eintretendes Nachrichten-Zwischenereignis',
    'Message intermediate throw event':
        'Ausgelöstes Nachrichten-Zwischenereignis',
    'Message start event': 'Nachrichten-Startereignis',
    'Message start event (non-interrupting)':
        'Nachrichten-Startereignis (nicht unterbrechend)',
    'Open {element}': 'Öffne {element}',
    'Parallel gateway': 'Paralleles Gateway',
    'Parallel multi-instance': 'Parallele Multi-Instanz',
    'Participant multiplicity': 'Multiplizität der Teilnehmer',
    'Receive task': 'Empfangen Aufgabe',
    Remove: 'Löschen',
    'Script task': 'Script Aufgabe',
    'Search in diagram': 'Im Diagramm suchen',
    'Send task': 'Senden Aufgabe',
    'Sequence flow': 'Sequenzfluss',
    'Sequential multi-instance': 'Sequenzielle Multi-Instanz',
    'Service task': 'Service Aufgabe',
    'Signal boundary event': 'Angeheftetes Signal-Zwischenereignis',
    'Signal boundary event (non-interrupting)':
        'Angeheftetes Signal-Zwischenereignis (nicht unterbrechend)',
    'Signal end event': 'Signal-Endereignis',
    'Signal intermediate catch event': 'Eintretendes Signal-Zwischenereignis',
    'Signal intermediate throw event': 'Ausgelöstes Signal-Zwischenereignis',
    'Signal start event': 'Signal-Startereignis',
    'Signal start event (non-interrupting)':
        'Signal-Startereignis (nicht unterbrechend)',
    'Start event': 'Startereignis',
    'Sub-process': 'Teilprozess',
    'Sub-process (collapsed)': 'Zugeklappter Prozess',
    'Sub-process (expanded)': 'Teilprozess (aufgeklappt)',
    Task: 'Aufgabe',
    'Terminate end event': 'Terminierungs-Endereignis',
    'Timer boundary event': 'Angeheftetes Zeit-Zwischenereignis',
    'Timer boundary event (non-interrupting)':
        'Angeheftetes Zeit-Zwischenereignis (nicht unterbrechend)',
    'Timer intermediate catch event': 'Eintretendes Zeit-Zwischenereignis',
    'Timer start event': 'Zeit-Startereignis',
    'Timer start event (non-interrupting)':
        'Zeit-Startereignis (nicht unterbrechend)',
    'Toggle non-interrupting': 'Nicht unterbrechend umschalten',
    Transaction: 'Transaktion',
    'User task': 'Benutzer Aufgabe',
    'already rendered {element}': '{element} bereits gerendert',
    'correcting missing bpmnElement on {plane} to {rootElement}':
        'Fehlendes BPMN-Element auf {plane} an {rootElement} korrigieren',
    'diagram not part of bpmn:Definitions':
        'Diagramm kein Teil von bpmn:Definitions',
    'element required': 'Element erforderlich',
    'element {element} referenced by {referenced}#{property} not yet drawn':
        'von {referenced}#{property} referenziertes Element {element} noch nicht gezeichnet',
    'failed to import {element}': '{element} konnte nicht importiert werden',
    'flow elements must be children of pools/participants':
        'Fluss-Elemente müssen Kinder von Pools/Teilnehmern sein',
    'missing {semantic}#attachedToRef': '{semantic} #attachedToRef fehlt',
    'more than {count} child lanes': 'mehr als {count} Kind-Lanes',
    'multiple DI elements defined for {element}':
        'mehrere DI-Elemente für {element} definiert',
    'no bpmnElement referenced in {element}':
        'In {element} wird kein BPMN-Element referenziert',
    'no diagram to display': 'kein Prozessmodell',
    'no parent for {element} in {parent}':
        'kein Eltern-Element für {element} in {parent}',
    'no plane for {element}': 'keine Ebene für {element}',
    'no process or collaboration to display': 'kein Prozess/Kollaboration',
    'no shape type specified': 'kein Element-Typ angegeben',
    'out of bounds release': 'außerhalb der Grenzen',
    'unknown di {di} for element {semantic}':
        'unbekanntes DI {di} für Element {semantic}',
    'unrecognized flowElement {element} in context {context}':
        'nicht erkanntes Flow-Element {element} im Kontext {context}',
    'unsupported bpmnElement for {plane}: {rootElement}':
        'nicht unterstütztes BPMN-Element für {plane}: {rootElement}',
    '{semantic}#{side} Ref not specified':
        '{semantic}#{side} Ref nicht angegeben',
} as const;
